import React, { useState, useEffect } from 'react';
import heroBackground from '../../Assets/Images/Aboutus/rm378-06.jpg';
import {
  FaChalkboardTeacher,
  FaComments,
  FaCogs,
  FaProjectDiagram
} from "react-icons/fa";
import AOS from 'aos';
import 'aos/dist/aos.css';
import '../../Assets/CSS/Contacts.scss';
import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';
import journeyBg from '../../Assets/Images/Aboutus/bg-3.jpg';
import axios from 'axios';
import "../../Assets/CSS/Styles.scss";


const DemoPage = () => {


 const [formData, setFormData] = useState({
    fullName: '',
    emailAddress: '',
    mobileNumber: '',
    instituteType: '',
    budgetRange: '',
    designation: '',
    institutionName: '',
    projectDetails: '',
    updatesOptIn: false,
  });

  const [success, setSuccessMessage] = useState('');
  const [error, setErrorMessage] = useState('');

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSuccessMessage('');
    setErrorMessage('');

    try {
      const res = await axios.post('http://localhost:8000/api/contact', formData);
      if (res.status === 201 || res.status === 200) {
        setSuccessMessage('Form submitted successfully!');
        setFormData({
          fullName: '',
          emailAddress: '',
          mobileNumber: '',
          instituteType: '',
          budgetRange: '',
          designation: '',
          institutionName: '',
          projectDetails: '',
          updatesOptIn: false,
        });
      }
    } catch (error) {
      console.error(error);
      setErrorMessage('Something went wrong. Please try again.');
    }
  };


  useEffect(() => {
    AOS.init({
      duration: 800,
      once: true,
      offset: 50,
    });
  }, []);

  const features = [
    {
      icon: <FaChalkboardTeacher size={28} />,
      title: "Personalized Feature Walkthrough",
      description: "See firsthand how our platform's specific features address your institution's unique challenges and goals.",
    },
    {
      icon: <FaComments size={28} />,
      title: "Real-time Q&A Session",
      description: "Get immediate answers to all your questions from our product experts, ensuring clarity on every aspect.",
    },
    {
      icon: <FaCogs size={28} />,
      title: "Customized Use Case Scenarios",
      description: "Explore how our solution can be applied to your day-to-day operations with tailored examples.",
    },
    {
      icon: <FaProjectDiagram size={28} />,
      title: "Integration Possibilities & Roadmaps",
      description: "Understand our seamless integration capabilities and get a glimpse into future enhancements.",
    },
  ];

  const responsive = {
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 3,
      partialVisibilityGutter: 40,
    },
    tablet: {
      breakpoint: { max: 1024, min: 640 },
      items: 2,
      partialVisibilityGutter: 30,
    },
    mobile: {
      breakpoint: { max: 640, min: 0 },
      items: 1,
      partialVisibilityGutter: 20,
    },
  };
  const testimonials = [
    {
      quote: "This ERP changed how we operate. Super easy to manage!",
      author: "Dr. Shalini Verma",
      institution: "National Institute of Management",
    },
    {
      quote: "The support and onboarding were seamless. Highly recommend.",
      author: "Prof. Mahesh Rao",
      institution: "Global Tech University",
    },
    {
      quote: "We saved a lot of time on admin tasks after switching.",
      author: "Anita Desai",
      institution: "Greenwood High School",
    },
    {
      quote: "Incredible dashboard and student tracking tools.",
      author: "Rajeev Menon",
      institution: "Bright Future Academy",
    },
    {
      quote: "Reliable, intuitive, and well-supported ERP system.",
      author: "Sonal Gupta",
      institution: "Springfield Public College",
    },
  ];

  const [openIndex, setOpenIndex] = useState(null);


  // Sample FAQ data - replace with your actual data
  const faqs = [
    {
      question: "How long is the demo?",
      answer: "Our typical demo lasts about 30-45 minutes, tailored to your specific needs and questions.",
    },
    {
      question: "Is it really free?",
      answer: "Yes, our demo is completely free of charge and comes with no obligations.",
    },
    {
      question: "Do I need technical knowledge?",
      answer: "No, absolutely not! Our demos are designed for anyone, regardless of technical background.",
    },
    {
      question: "What happens after the demo?",
      answer: "After the demo, we’ll summarize key points and discuss next steps — no pressure at all.",
    },
  ];

  useEffect(() => {
    const stars = document.querySelectorAll(".clip-rect");

    stars.forEach((rect, i) => {
      let width = 0;
      setTimeout(() => {
        const interval = setInterval(() => {
          if (width >= 20) {
            clearInterval(interval);
          } else {
            width += 0.3; // Controls how smooth the fill is
            rect.setAttribute("width", width.toString());
          }
        }, 50); // Controls speed: increase for slower fill
      }, i * 1000); // Delay each star
    });
  }, []);

  return (
    <div className="demo-page-container font-ui text-[#4B5563] bg-white mt60">
      {/* Hero Section */}
      <div className="demo-page-container font-ui text-[#4B5563] bg-white">

        {/* Hero Section */}
        <div
          className="relative h-[500px] md:h-[488px] bg-cover bg-center flex items-center justify-center p-4 text-white overflow-hidden "
        >
          <div
            className="absolute inset-0 bg-center bg-cover animate-slowZoom "
            style={{ backgroundImage: `url(${heroBackground})`, zIndex: 0 }}
          ></div>
          <div className="absolute inset-0 bg-black bg-opacity-60 backdrop-blur-[3px] z-1"></div>
          {/* Text Content */}
          <div className="relative z-5 text-center max-w-4xl mx-auto">
            <div className="mb-6">
              <div className="inline-flex items-center px-3 py-1 mb-4 text-sm font-medium text-black bg-[#ffdd9d] rounded-full">
                <svg className="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"></path></svg>
                Ready to Transform Your Institution?
              </div>
            </div>
            <h1 className="font-heading font-bold-500 text-white  lg:text-5xl text-center mb-6">
              See How Our ERP Can{" "}
              <br />
              <span className="text-[#FBBF24]  mt-4">
                Transform Your Institution
              </span>
            </h1>
            <p className="font-ui text-white text-md leading-6 mt-6 mb-8 p">
              Get a personalized walkthrough of GlobalSolutions' cloud-based ERP
              suite. We'll show you how to digitize, automate, and analyze your
              operations — no tech knowledge required.
            </p>
            <p className="text-sm font-ui opacity-90">
              No spam. No pushy sales. Just value.
            </p>
          </div>
        </div>
      </div>

      {/* Features Section */}
      <section
        className="relative py-16 bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: `url(${journeyBg})`,
          maskImage:
            'linear-gradient(to bottom, transparent 0%, black 10%, black 90%, transparent 100%)',
          WebkitMaskImage:
            'linear-gradient(to bottom, transparent 0%, black 10%, black 90%, transparent 100%)',
        }}

      >
        <div className="absolute inset-0 bg-white bg-opacity-70 z-0" ></div>
        <h2 className=" Headers relative z-10 font-heading font-ui">What You'll Get In Your Demo</h2>
        <p className="text-center text-[15px] mb-20 relative z-10;
            color: #374151 !important; font-ui mb-10">Experience a comprehensive walkthrough tailored specifically to your institution's needs.</p>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4  gap-5 max-w-6xl mx-auto relative z-10">
          {features.map((f, i) => (
            <div
              key={i}
              className="relative bg-white border-2 border-amber-400 rounded-xl shadow-sm p-6 pt-10 text-center transition-all duration-300 hover:scale-105 hover:shadow-lg"
            >
              {/* Floating Icon */}
              <div className="absolute -top-8 left-1/2 transform -translate-x-1/2">
                <div className="w-16 h-16 flex items-center justify-center rounded-full bg-amber-100 border-2 border-white shadow-md">
                  <svg
                    className="h-8 w-8 text-amber-500"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                    strokeWidth="2"
                  >
                    {f.icon}
                  </svg>
                </div>
              </div>

              {/* Content */}
              <div className="mt-10">
                <h3 className="text-[20px] font-bold text-[#111827] mb-2">{f.title}</h3>
                <p className="text-[15px] text-[#374151] font-ui mb-2">{f.description}</p>
              </div>
            </div>
          ))}
        </div>

      </section>


      {/* Form Section */}
      <section className="py-12 px-4 sm:px-6 lg:px-8 bg-[#F9FAFB]">
        <div className="text-center mb-6">
          <h2 className="Headers font-heading font-ui text-xl sm:text-2xl">Book Your Free Demo</h2>
          <p className="text-[14px] text-[#374151] font-ui">
            Fill out the form below and we'll reach out within 24 hours
          </p>
        </div>

        <div className="max-w-xl mx-auto bg-white p-6 sm:p-8 rounded-lg shadow-md border border-[#F59E0B]">
          {success && <p className="text-green-600 mb-3 text-sm">{success}</p>}
          {error && <p className="text-red-600 mb-3 text-sm">{error}</p>}

          <form onSubmit={handleSubmit} className="space-y-5">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">

              <div>
                <label htmlFor="fullName" className="block text-sm font-medium text-[#111827] mb-1">
                  Full Name <span className="text-red-500">*</span>
                </label>
                <input
                  id="fullName"
                  name="fullName"
                  type="text"
                  required
                  placeholder="Enter your full name"
                  value={formData.fullName}
                  onChange={handleChange}
                  className="w-full p-2.5 border border-[#F59E0B] rounded focus:outline-none focus:ring-2 focus:ring-[#F59E0B]"
                />
              </div>

              <div>
                <label htmlFor="emailAddress" className="block text-sm font-medium text-[#111827] mb-1">
                  Email Address <span className="text-red-500">*</span>
                </label>
                <input
                  id="emailAddress"
                  name="emailAddress"
                  type="email"
                  required
                  placeholder="your.email@domain.com"
                  value={formData.emailAddress}
                  onChange={handleChange}
                  className="w-full p-2.5 border border-[#F59E0B] rounded focus:outline-none focus:ring-2 focus:ring-[#F59E0B]"
                />
              </div>

              <div>
                <label htmlFor="mobileNumber" className="block text-sm font-medium text-[#111827] mb-1">
                  Mobile Number <span className="text-red-500">*</span>
                </label>
                <input
                  id="mobileNumber"
                  name="mobileNumber"
                  type="tel"
                  required
                  placeholder="+91 12345 67890"
                  value={formData.mobileNumber}
                  onChange={handleChange}
                  className="w-full p-2.5 border border-[#F59E0B] rounded focus:outline-none focus:ring-2 focus:ring-[#F59E0B]"
                />
              </div>

              <div>
                <label htmlFor="instituteType" className="block text-sm font-medium text-[#111827] mb-1">
                  Institution Type <span className="text-red-500">*</span>
                </label>
                <select
                  id="instituteType"
                  name="instituteType"
                  required
                  value={formData.instituteType}
                  onChange={handleChange}
                  className="w-full p-2.5 border border-[#F59E0B] rounded bg-white focus:outline-none focus:ring-2 focus:ring-[#F59E0B]"
                >
                  <option value="">Select institute type</option>
                  <option value="technical">Technical</option>
                  <option value="medical">Medical</option>
                  <option value="engineering">Engineering</option>
                  <option value="arts">Arts, Commerce, Science</option>
                  <option value="corporate">Corporate</option>
                  <option value="other">Other</option>
                </select>
              </div>

              <div>
                <label htmlFor="budgetRange" className="block text-sm font-medium text-[#111827] mb-1">
                  Budget Range
                </label>
                <select
                  id="budgetRange"
                  name="budgetRange"
                  value={formData.budgetRange}
                  onChange={handleChange}
                  className="w-full p-2.5 border border-[#F59E0B] rounded bg-white focus:outline-none focus:ring-2 focus:ring-[#F59E0B]"
                >
                  <option value="">Select budget range</option>
                  <option value="less-than-10k">Less than 10,0000</option>
                  <option value="10k-50k">10,0000 - 50,0000</option>
                  <option value="50k-100k">50,0000 - 100,0000</option>
                  <option value="more-than-100k">More than 100,0000</option>
                </select>
              </div>

              <div>
                <label htmlFor="designation" className="block text-sm font-medium text-[#111827] mb-1">
                  Role / Designation <span className="text-red-500">*</span>
                </label>
                <input
                  id="designation"
                  name="designation"
                  type="text"
                  required
                  placeholder="e.g. Principal, Director"
                  value={formData.designation}
                  onChange={handleChange}
                  className="w-full p-2.5 border border-[#F59E0B] rounded focus:outline-none focus:ring-2 focus:ring-[#F59E0B]"
                />
              </div>

              <div className="md:col-span-2">
                <label htmlFor="institutionName" className="block text-sm font-medium text-[#111827] mb-1">
                  Institution / Company Name <span className="text-red-500">*</span>
                </label>
                <input
                  id="institutionName"
                  name="institutionName"
                  type="text"
                  required
                  placeholder="Your institution or company"
                  value={formData.institutionName}
                  onChange={handleChange}
                  className="w-full p-2.5 border border-[#F59E0B] rounded focus:outline-none focus:ring-2 focus:ring-[#F59E0B]"
                />
              </div>
            </div>

            <div>
              <label htmlFor="projectDetails" className="block text-sm font-medium text-[#111827] mb-1">
                Project Details <span className="text-red-500">*</span>
              </label>
              <textarea
                id="projectDetails"
                name="projectDetails"
                rows="3"
                required
                placeholder="Describe your project or goals..."
                value={formData.projectDetails}
                onChange={handleChange}
                className="w-full p-2.5 border border-[#F59E0B] rounded focus:outline-none focus:ring-2 focus:ring-[#F59E0B]"
              ></textarea>
            </div>

            <div className="flex items-start">
              <input
                type="checkbox"
                id="updatesOptIn"
                name="updatesOptIn"
                className="mt-1"
                checked={formData.updatesOptIn}
                onChange={handleChange}
              />
              <label htmlFor="updatesOptIn" className="ml-2 text-sm text-[#111827]">
                I'd like to receive updates about new features, case studies, and educational technology insights.
              </label>
            </div>

            <input type="hidden" name="formType" value="book-demo" />

            <div>
              <button
                type="submit"
                className="w-full bg-[#F59E0B] text-white py-2.5 text-sm rounded-md font-semibold hover:opacity-90"
              >
                Send Message
              </button>
            </div>

            <p className="text-xs text-[#6B7280] text-center mt-2">
              We respect your privacy and will never share your information.
            </p>
          </form>
        </div>
      </section>

      {/* Testimonials */}
      <section className="py-16  px-4 mt-4 sm:px-6 lg:px-8 ">
        <h2 className=" Headers font-heading font-ui">Trusted by Leading Institutions</h2>
        <p className="text-center text-[15px] ;
                   color: #374151 !important; font-ui mb-10">See what our clients says out there transformation journey</p>
        <Carousel
          responsive={responsive}
          infinite
          autoPlay
          autoPlaySpeed={3500}
          transitionDuration={600}
          containerClass="max-w-7xl mx-auto"
          itemClass="px-4"
          arrows={false}
          showDots={false}
          pauseOnHover
          draggable={false}
          swipeable={false}
          keyBoardControl={false}
        >
          {testimonials.map((t, i) => (
            <div
              key={i}
              className="bg-[#FFF8F4] p-8 rounded-lg shadow-md border border-[#FEE2E2] h-full"
            >
              <div className="flex mb-4">
                {Array(5)
                  .fill()
                  .map((_, j) => (
                    <div key={j} className="relative w-6 h-6 mr-1">
                      {/* Empty star */}
                      <svg
                        className="absolute top-0 left-0 w-full h-full text-gray-300"
                        fill="currentColor"
                        viewBox="0 0 20 20"
                      >
                        <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.538 1.118l-2.8-2.034a1 1 0 00-1.176 0l-2.8 2.034c-.783.57-1.838-.197-1.538-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.92 8.72c-.783-.57-.381-1.81.588-1.81h3.462a1 1 0 00.95-.69l1.07-3.292z" />
                      </svg>

                      {/* Filled star */}
                      <svg
                        className="absolute top-0 left-0 w-full h-full text-yellow-400"
                        fill="currentColor"
                        viewBox="0 0 20 20"
                      >
                        <defs>
                          <clipPath id={`clip-star-${j}-${i}`}>
                            <rect x="0" y="0" width="20" height="20" />
                          </clipPath>
                        </defs>
                        <g clipPath={`url(#clip-star-${j}-${i})`}>
                          <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.538 1.118l-2.8-2.034a1 1 0 00-1.176 0l-2.8 2.034c-.783.57-1.838-.197-1.538-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.92 8.72c-.783-.57-.381-1.81.588-1.81h3.462a1 1 0 00.95-.69l1.07-3.292z" />
                        </g>
                      </svg>
                    </div>
                  ))}
              </div>

              <p className="text-sm text-[#374151] font-ui mb-7">"{t.quote}"</p>
              <p className="font-semibold font-ui text-[#111827]">{t.author}</p>
              <p className="text-sm font-ui text-[#6B7280]">{t.institution}</p>
            </div>
          ))}
        </Carousel>
      </section>


      {/* FAQs */}
      <section
        className="relative py-16 bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: `url(${journeyBg})`,
          maskImage:
            'linear-gradient(to bottom, transparent 0%, black 10%, black 90%, transparent 100%)',
          WebkitMaskImage:
            'linear-gradient(to bottom, transparent 0%, black 10%, black 90%, transparent 100%)',
        }}

      >
        <div className="absolute inset-0 bg-white bg-opacity-70 z-0" ></div>
        <div className="text-center relative z-10 mb-12 ">
          <h2 className="Headers font-heading font-ui">Frequently Asked Questions</h2>
          <p className="text-center text-[15px] !important; color: #374151 !important; font-ui mb-10">
            Get answers to common questions about our demo process
          </p>
        </div>

        <div className="max-w-4xl relative z-10 mx-auto grid grid-cols-1 gap-4">
          {faqs.map((f, i) => (
            <div key={i} className="rounded-lg  relative z-10 shadow-xl border border-[#F59E0B] overflow-hidden">
              <button
                onClick={() => setOpenIndex(openIndex === i ? null : i)}

                className="flex justify-between items-center w-full py-4 px-6 text-left"
              >
                <span className="font-semibold relative z-10text-[#111827] relative z-10 text-lg">{f.question}</span>
                <svg
                  className="w-5 h-5 text-[#FF6A00] flex-shrink-0"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  viewBox="0 0 24 24"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path strokeLinecap="round" strokeLinejoin="round" d="M9 5l7 7-7 7" />
                </svg>
              </button>
              {/* The answer content will expand the height when open */}
              {openIndex === i && <div className="p-6 pt-0 text-[#4B5563] relative z-10 animate-popupInOut">{f.answer}</div>}
            </div>
          ))}
        </div>
      </section>
    </div>
  );
};
export default DemoPage;
